module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki200-7e432a089040b2511a11273fb5391307.png";